<template>
  <div class="wrapper d-flex flex-nowrap" id="horizontal-desktop">
    <slot />
  </div>
</template>


<script>
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { mapGetters } from "vuex";

export default {
  computed: {
    ...mapGetters({ isImageReady: "isImageReady" }),
  },
  watch: {
    isImageReady(newValue) {
      if (newValue) {
        this.setupHorizontalScroll();
      }
    },
  },

  methods: {
    setupHorizontalScroll() {
      const sections = gsap.utils.toArray(".horizontal-section");

      let maxWidth = 0;
      sections.forEach((section) => {
        maxWidth += section.offsetWidth;
      });

      // ScrollTrigger.addEventListener("refreshInit", maxWidth);
      let viewportWidth = document.documentElement.clientWidth;
      gsap.to(sections, {
        x: () => `-${maxWidth - viewportWidth}`,
        ease: "none",
        scrollTrigger: {
          trigger: ".wrapper",
          pin: true,
          start: "top top",
          scrub: 1,
          end: () => `+=${maxWidth}`,
          invalidateOnRefresh: true,
        },
      });
    },
  },
  mounted() {
    gsap.registerPlugin(ScrollTrigger);
  },
};
</script>

<style lang="postcss" scoped>
.wrapper {
  display: flex !important;
  flex-wrap: nowrap !important;
}

.section {
  height: 100vh !important;
  align-items: center !important;
  justify-content: center !important;
  flex-shrink: 0 !important;
  display: flex !important;
}
</style>